/**
 * Footer FAQ Accordion
 * Converts a <ul> list of FAQ questions in the footer into interactive accordions.
 * Matches question text to predefined answers and injects toggle behaviour.
 */

const FAQ_DATA = [
  {
    q: 'How long does delivery take?',
    a: 'Delivery takes 5-11 days'
  },
  {
    q: 'What ages are your toys for?',
    a: 'Ages suitability: Products are suitable for children between the ages 0-3 years+'
  },
  {
    q: 'Are your toys safe and certified?',
    a: 'Yes! All our toys meet South African safety standards and are made from non-toxic, eco-friendly materials.'
  },
  {
    q: 'What is your return policy?',
    a: 'We offer a 30-day return policy on all unopened items. If something isn\u2019t right, we\u2019ll make it right.'
  }
];

function initFooterFaq() {
  const footer = document.querySelector('.footer-content');
  if (!footer) return;

  // Find the <ul> inside the footer that contains FAQ questions
  const lists = footer.querySelectorAll('ul');

  lists.forEach((ul) => {
    const items = ul.querySelectorAll('li');
    let matchCount = 0;

    items.forEach((li) => {
      const text = li.textContent.trim();
      if (FAQ_DATA.find((faq) => text === faq.q)) matchCount++;
    });

    // Only convert if most items match FAQ questions
    if (matchCount < 2) return;

    const container = document.createElement('div');
    container.className = 'footer-faq-list';

    items.forEach((li) => {
      const text = li.textContent.trim();
      const match = FAQ_DATA.find((faq) => text === faq.q);

      const wrapper = document.createElement('div');
      wrapper.className = 'footer-faq-item';

      const question = document.createElement('button');
      question.className = 'footer-faq-q';
      question.type = 'button';
      question.setAttribute('aria-expanded', 'false');
      question.innerHTML = '<span>' + (match ? match.q : text) + '</span><span class="footer-faq-icon">+</span>';

      const answer = document.createElement('div');
      answer.className = 'footer-faq-a';
      answer.setAttribute('aria-hidden', 'true');
      answer.innerHTML = '<p>' + (match ? match.a : '') + '</p>';

      question.addEventListener('click', function () {
        var isOpen = wrapper.classList.toggle('is-open');
        question.setAttribute('aria-expanded', String(isOpen));
        answer.setAttribute('aria-hidden', String(!isOpen));
      });

      wrapper.appendChild(question);
      wrapper.appendChild(answer);
      container.appendChild(wrapper);
    });

    // Replace the <ul>'s parent rte-formatter (or the ul itself)
    const rte = ul.closest('rte-formatter');
    const target = rte || ul;
    target.parentNode.insertBefore(container, target);
    target.style.display = 'none';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFooterFaq);
} else {
  initFooterFaq();
}
